import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import isUsingArtemisStyles from '../../../../v2/selectors/isUsingArtemisStyles';
import useStyles from './SocialSharingReferralCode.styles';
import Translation from '../../../../v2/lang/Translation';

export function SocialSharingReferralCode(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <>
      <h3 className={classes.heading}>
        <Translation>referralsSocialSharing.referralCode.heading</Translation>
      </h3>
      <div className={classes.subheading}>
        <Translation>referralsSocialSharing.referralCode.subheading</Translation>
      </div>
    
      <div className={classes.referralCode}>{props.referralCode}</div>
    
      <div className={classes.explanation}>
        <Translation>referralsSocialSharing.referralCode.explanation</Translation>
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  referralCode: state.socialSharing.referralCode,
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

SocialSharingReferralCode.propTypes = {
  referralCode: PropTypes.string.isRequired,
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(
  mapStateToProps,
)(SocialSharingReferralCode);
